import React, { Component } from "react";
import { MdClose } from "react-icons/md";
import InfiniteScroll from "react-infinite-scroll-component";
import Empty from "../../../base/features/blocks/Empty";
import Spinner from "../../../base/features/micro/Spinner";
import OrderBlock from "../../../base/features/blocks/OrderBlock";
import { getUserShopOrders } from "./services";
import { getShopUid } from "../../../settings/domainManager";

class ShopOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: null,
      searchKey: "",
      shopUid: getShopUid(),
      nextOrders: "",
      hasMoreOrders: false,
    };
  }
  componentDidMount() {
    this.getOrders();
  }
  fetchMoreOrders() {
    getUserShopOrders(this.state.shopUid, this.state.nextOrders, "").then(
      (items) => {
        if (items) {
          let newOrders = this.state.orders;
          newOrders = newOrders.concat(items.results);

          this.setState({
            orders: newOrders,
            nextOrders: items.next,
            hasMoreOrders: items.next ? true : false,
          });
        }
      }
    );
  }
  getOrders() {
    let q = this.state.searchKey;
    getUserShopOrders(this.state.shopUid, null, q).then((items) => {
      if (q === this.state.searchKey && items) {
        this.setState({
          orders: items.results,
          hasMoreOrders: items.next ? true : false,
          nextOrders: items.next,
        });
      }
    });
  }
  render() {
    return (
      <div className="row mx-0 px-0">
        <div
          className="col-12 px-4 py-3 text-center position-sticky bg-white"
          style={{ top: "59px", zIndex: "99999" }}
        >
          <input
            type="text"
            value={this.state.searchKey}
            onChange={(e) =>
              this.setState({ searchKey: e.target.value }, () => {
                this.getOrders();
              })
            }
            className="form-control px-3 py-2 rounded14 w-100"
            style={{ height: "44px" }}
            placeholder="جستجو کنید"
          />
          {this.state.searchKey.length !== 0 && (
            <MdClose
              size={26}
              style={{ left: "37px", top: "0", bottom: "0" }}
              className="position-absolute my-auto"
              onClick={() =>
                this.setState({ searchKey: "" }, () => {
                  this.getOrders();
                })
              }
            />
          )}
        </div>
        {this.state.orders ? (
          <section className="px-0">
            <InfiniteScroll
              dataLength={this.state.orders.length}
              next={() => this.fetchMoreOrders()}
              hasMore={this.state.hasMoreOrders}
              className="row mx-0 px-4"
              loader={<Spinner />}
            >
              {this.state.orders.length === 0 ? (
                <Empty text={"سفارشی ثبت نشده است."} />
              ) : (
                this.state.orders.map((order, o) => (
                  <OrderBlock order={order} />
                ))
              )}
            </InfiniteScroll>
          </section>
        ) : (
          <Spinner />
        )}
      </div>
    );
  }
}

export default ShopOrders;
